import styled from "styled-components";

export const OptionContainer = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 72px;
  gap: 5px;
  background-color: ${({ isSelected }) => (isSelected ? "#dce0fc" : "#c9cffe")};
  transition: background-color 0.3s ease-in-out;
  border: none;
  color: rgb(64, 86, 244);
  animation: color 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    color: ${({ isSelected }) => !isSelected && "#1e1f43"};
  }
`;
